import React, { Component } from 'react';
import Select from 'react-select'
import Swal from 'sweetalert2';
import swal from 'sweetalert';
import { API_URL,SendPasswordByMail,SwalBlokUI } from '../../../config'
import $ from 'jquery'
import MaterialTable, { MTableToolbar } from 'material-table';
import BlockUi from 'react-block-ui';
import { alpha } from '@material-ui/core/styles' 
import Multiselect from 'multiselect-react-dropdown';

class BackofficeNew extends Component {
    tableRef = React.createRef(); 

    
    constructor(props) {
       
        super(props); 
        this.toggleBlocking = this.toggleBlocking.bind(this);
        this.state = {
            blocking: false,
            user_zone: { label: "North", value: "North" },
            user_type: { label: "Sales Officer", value: "Sales Officer" },
            user_region : {label: "Select Region", value: "Select Region"},
            bm_name: {label: "Select BM", value: "Select BM"},
            zsm_name :{label: "Select ZSM", value: "Select ZSM"},
            user_status: { label: "Select Status", value: "Select Status" },
            emailID: "",
            user_type_disable:false,
            showDistSelectionMenu:0,
            pwd: "",
            loginIP: "",
            loginBrowser: "",
            deviceType: "",
            userLocation: "",
            logIsp: "",
            ii: 0,
            actions: [],
            pLogo: "",
            opcarr: [],
            count: 1,
            options: [],
            // options: JSON.parse(localStorage.getItem("distlist")),
            empdet:[],
            selectedit:[],
            load1:false
        }
        const grid_height= $(window).height()-$(".header-navbar").height()-200;
        this.max_body_heght= grid_height+"px";
    }

    user_status_options = [
        { value: 'Active', label: 'Active'},
        { value: 'Inactive', label: 'Inactive' }
      ];

    use_zone_options = [
        { value: 'North', label: 'North'},
        { value: 'East', label: 'East' },
        { value: 'West', label: 'West' },
        { value: 'South', label: 'South' },
        { value: 'Central', label: 'Central' }
      ];

      user_region_options = [
        { value: 'Andhra Pradesh', label: 'Andhra Pradesh'},
        { value: 'NESA', label: 'NESA' },
        { value: 'Bihar', label: 'Bihar' },
        { value: 'Chandigarh', label: 'Chandigarh' },
        { value: 'Chhattisgarh', label: 'Chhattisgarh' },
        { value: 'Delhi', label: 'Delhi' },
        { value: 'Gujarat', label: 'Gujarat' },
        { value: 'Haryana', label: 'Haryana' },
        { value: 'Himachal Pradesh', label: 'Himachal Pradesh' },
        { value: 'J&K', label: 'J&K' },
        { value: 'Jharkhand', label: 'Jharkhand' },
        { value: 'Karnataka', label: 'Karnataka' },
        { value: 'Kerala', label: 'Kerala' },
        { value: 'West Bengal', label: 'West Bengal' },
        { value: 'Madhya Pradesh', label: 'Madhya Pradesh' },
        { value: 'Goa', label: 'Goa' },
        { value: 'Mah-ROM', label: 'Mah-ROM' },
        { value: 'Mah-Pune', label: 'Mah-Pune' },
        { value: 'Mumbai', label: 'Mumbai' },
        { value: 'Odisha', label: 'Odisha' },
        { value: 'Punjab', label: 'Punjab' },
        { value: 'Rajasthan', label: 'Rajasthan' },
        { value: 'Tamilnadu', label: 'Tamilnadu' },
        { value: 'Telangana', label: 'Telangana' },
        { value: 'UP-Easter&Central', label: 'UP-Easter&Central' },
        { value: 'UP-Western', label: 'UP-Western' },
        { value: 'Uttarakhand', label: 'Uttarakhand' }
      ];

      bm_name_options = [
        { value: 'Jignesh Nagadia', label: 'Jignesh Nagadia' },
        { value: 'Saikat Chakraborty', label: 'Saikat Chakraborty' },
        { value: 'Vacant BM West', label: 'Vacant BM West' },
        { value: 'Rahul Sachan', label: 'Rahul Sachan' },
        { value: 'Vacant BM MP', label: 'Vacant BM MP' },
    { value: 'Parameswaran T.S.', label: 'Parameswaran T.S.' },
    { value: 'Balakrishnan P', label: 'Balakrishnan P' },
    { value: 'karthikeyan selvaraj', label: 'karthikeyan selvaraj' },
    { value: 'Susheel Kumar B.', label: 'Susheel Kumar B.' },
    { value: 'Praveen Dara', label: 'Praveen Dara' },
    { value: 'Pranay Sengupta', label: 'Pranay Sengupta' },
    { value: 'Vacant BM-BH', label: 'Vacant BM-BH' },
    { value: 'Vacant BM-JH', label: 'Vacant BM-JH' },
    { value: 'Vacant BM-WB', label: 'Vacant BM-WB' },
    { value: 'Deepak Vashistha', label: 'Deepak Vashistha' },
    { value: 'Ritesh Anand', label: 'Ritesh Anand' },
    { value: 'Sujeet Dwivedi', label: 'Sujeet Dwivedi' },
    { value: 'Vikrant Singh', label: 'Vikrant Singh' }
    ];

      zsm_name_options = [
        { value: 'Prashant Kapile', label: 'Prashant Kapile'},
        { value: 'Ajay Chavda', label: 'Ajay Chavda' },
        { value: 'Sameer Srivastava', label: 'Sameer Srivastava' },
        { value: 'Rahul Srivastava', label: 'Rahul Srivastava' },
        { value: 'Arnab Ghosh', label: 'Arnab Ghosh' }
      ];

      use_type_options = [
        { value: 'Back Office', label: 'Back Office'},
        { value: 'Sales Officer', label: 'Sales Officer' } ,
        { value: 'Approver', label: 'Approver' } ,
        { value: 'BM', label: 'Branch Manager' },
        { value: 'ZSM', label: 'Zonal Manager' }
      ];

      
      handleUserZoneChange(value) {
        this.setState({ user_zone: value })
    }
    toggleBlocking() {
        this.setState({blocking: !this.state.blocking});
      }

    handleUserTypeChange(value) {
            console.log(value.value);
            this.setState({ user_type: value })
            if(value.value==="Back Office" || value.value=="Approver"  || value.value=="Price Manager" || value.value==="BM" || value.value==="ZSM")
            {
                this.setState({ showDistSelectionMenu: 0 })
                this.setState({selectedit:[]});
            }
            else
            {
                this.setState({ showDistSelectionMenu: 1 })
            }
         
        
    }

    onSelect = (selectedList, selectedItem) => {
        
        this.setState({selectedit:selectedList})
     }
     
     onRemove = (selectedList, removedItem) => {
        
         this.setState({selectedit:selectedList})
     }

     submit() { 
        let msg="" 
       let arr1=[]
       let arr=[]    
       for(let i=0;i<this.state.selectedit.length;i++){
           let ddd={
               distCode:this.state.selectedit[i].id,
               distName:this.state.selectedit[i].name
           }
           arr1.push(ddd)
       }
        let data1 = {
           "empCode":document.getElementById("fcode").value,
            "empName":document.getElementById("lname").value,
            "emailId":document.getElementById("email").value,
            "phoneNo":document.getElementById("PH").value,
            "birthPlace":document.getElementById("DOB").value,
            "address":this.state.user_region.value,
            "empType":this.state.user_type.value,
            "user_type":this.state.user_type.value,
            "empZone": this.state.user_zone.value,
            "reportingToLvl2":this.state.bm_name.value,
            "reportingToLvl3":this.state.zsm_name.value,
            "status":this.state.user_status.value,
            "distributors":arr1
            }
           
         //validations
        if(document.getElementById("fcode").value.trim() == "")
        {
            swal({
                title: "OOPS!",
                text: "Please enter Employee Code!",
                icon: "warning",
            });

          
            return false;
        }
            else if(document.getElementById("lname").value.trim() == "")
            {
                swal({
                    title: "OOPS!",
                    text: "Please enter Employee Name!",
                    icon: "warning",
                });
    
                return false;
            }
            else if(document.getElementById("email").value.trim() == "")
        {
            swal({
                title: "OOPS!",
                text: "Please enter Email Id!",
                icon: "warning",
            });
 
            return false;
        }
        else if(     (document.getElementById("PH").value.length)!=10)
        { 
            swal({
                title: "OOPS!",
                text: "Please enter Valid Phone No.",
                icon: "warning",
            });

            return false;
        }
         
        //////
        let logourl = API_URL + "/addEmployee";
        if(this.state.count==2){
            msg="Edited Succesfully"
            logourl = API_URL + "/editEmployee";
        }
        else{ 
            logourl = API_URL + "/addEmployee";           
            msg = "Added Sucessfully"
        } 
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': localStorage.getItem('token')
            },
            body: JSON.stringify(data1)
        };
        this.toggleBlocking();
        fetch(logourl, requestOptions)
            .then(res => res.json())
            .then(json => {
               // alert("addd")
                //this.setState({usrdet:json})
                if (1==1) {
                    swal({
                        title: "Done!",
                        text: msg,
                        icon: "success",
                    });
                    // this.forceUpdate();
                    document.getElementById("close").click()
                    this.reset()
                    this.tableRef.current.onQueryChange();
                    this.setState({options:arr})
                    
                }
            })
            .catch((e) => {
                swal({
                    title: "OOPS!",
                    text: e,
                    icon: "warning",
                });

                console.log(e)
            })
        //////

    }
    
    
     componentDidMount(){  
    

        this.getDist("");
         console.clear()   
    }

    addkoro(){
        this.setState({count:1})
        this.reset()
    }
 
    getDist(val)
    {
        let emp_code = $("#fcode").val()

        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json','authorization': localStorage.getItem('token') }, 
        };
     
        let url = API_URL + "/titpl/wiki_common/getCustomersWithoutSO?s_text="+val+"&emp_code="+emp_code;
        fetch(url, requestOptions)
            .then(res => res.json())
            .then(json => {

                let arr=[]
                for(let i=0;i<json.length;i++){ 
                    let d1={
                        name:json[i].customername+'('+json[i].customercode+')',
                        id:json[i].customercode
                    }
                    // console.log(arr)
                    arr.push(d1) 
                    
                }

                this.setState({options:arr})
        
            })
            .catch( (e) => {
 
                console.log(e)
            })
    }

    edit(det){
        this.reset()
        console.log("Clicked EDit");
        let dist=[];
        //to get the dist
        $.ajax({
            type: "POST",	
            headers: {
                'Content-Type': 'application/json',
                'authorization': localStorage.getItem('token')
              }, 
            url: API_URL + '/distributor_master/GetDistributorByEmp?empCode='+det.emp_code,
            async:true,		
            success:  function GetDistributorByEmpSuccess(responce)
            {	
                responce = eval('(' + responce + ')');
                //  console.log(responce);
                dist = responce['data'];
          
                //old
                 console.log(dist)
                 let arr=[]
                 let locdist=this.state.options;
                //  console.log(locdist[0].id)
         
                 for(let i=0;i<dist.length;i++){ 
                    let d1={
                        name:dist[i].distname,
                        id:dist[i].distcode
                    }
                  
                    arr.push(d1) 
                    
                }

                 this.setState({selectedit:arr})
                
         
              
                 this.setState({count:2})
                
                 document.getElementById("fcode").setAttribute("disabled","true")
                 document.getElementById("fcode").value=det.emp_code
                 document.getElementById("lname").value=det.emp_name
               //  document.getElementById("email").setAttribute("disabled","true")
                 document.getElementById("email").value=det.email_id
                 document.getElementById("PH").value=det.phone_no
                 document.getElementById("DOB").value=det.birth_place
              
                 document.getElementById("PPP").value=det.address;
                // document.getElementById("UT").setAttribute("disabled","true")
                 //document.getElementById("UT").value="Sales Officer";
                 
                 this.setState({ user_zone: { value: det.zone, label: det.zone} })
                 this.setState({ user_type_disable: true })  
                 this.setState({ user_type: { value: det.usertype, label: det.usertype} })  
                 this.setState({ user_region: { value: det.address, label: det.address} })
                 this.setState({user_status:{value: det.status,label:  det.status}})
                 this.setState({bm_name :{value: det.rpt_lvl2,label:  det.rpt_lvl2}})
                 this.setState({zsm_name:{value: det.rpt_lvl3,label:  det.rpt_lvl3}})
                 

                 if( det.usertype==="Sales Officer")
                 {
                     this.setState({ showDistSelectionMenu: 1})
                    
                 }
                 else
                 {
                    this.setState({ showDistSelectionMenu: 0 })
                 }

                 console.log(this.state)
              //   document.getElementById("zone1").value=det.zone
                // document.getElementById ("distributors":arr1)
                 
          
            }.bind(this)
        });
       
      
        
        
    }
    reset(){
        document.getElementById("fcode").removeAttribute("disabled")
        document.getElementById("email").removeAttribute("disabled")
       // document.getElementById("UT").removeAttribute("disabled")
    
        this.setState({selectedit:[]})
    
        document.getElementById("fcode").value=""
        document.getElementById("lname").value=""
        document.getElementById("email").value=""
        document.getElementById("PH").value=""
        document.getElementById("DOB").value=""
        document.getElementById("PPP").value=""
        document.getElementById("ustat").value=""
       // document.getElementById("UT").value=""
        //document.getElementById("zone1").value=""
      }
      SendPasswordByMailByEmployeeLogin(code)
      {
            
        Swal.fire({
          html: 'Do you want to Send Password to Employee Mail',
         
          showCancelButton: true,
          cancelButtonColor:"#932708",
          confirmButtonColor:"#324081",
          confirmButtonText: 'Send Mail <i class="fas fa-check mr-50"></i> ',
          cancelButtonText: `Cancel <i class="fas fa-times-circle mr-50"></i> `,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) { 
   
            SendPasswordByMail(code);
          } else if (result.isDenied) {
           // Swal.fire('Changes are not saved', '', 'info')
          }
        })
      }
   
  
    render() {
 
        return (
            <>
            <div className="App">
             
              <MaterialTable  
              tableRef={this.tableRef}
              style={{border: '0px solid red'}} 
                title="User Details" minRows={10}
                componentssss={{
                    Toolbar: props => (
                        <div style={{ backgroundColor: '#e8eaf5' }}>
                            <MTableToolbar {...props} />
                        </div>
                    )}}
                columns={[
                    { title: "Login Id", field: "emp_code" },
                    { title: "Employee Name", field: "emp_name" },
                    { title: "Email ID", field: "email_id" },
                    { title: "Phone No", field: "phone_no" }, 
                    { title: "User Type", field: "usertype" }, 
                    { title: "Status", field: "status" }, 
                    { title: "Zone", field: "zone" } ,
                    { title: "Region", field: "address" } ,
                    { title: "BM", field: "rpt_lvl2" } ,
                    { title: "ZSM", field: "rpt_lvl3" } 
                    // { title: "Action", field: "action" }, 
                    
                  ]}
                
                options={{maxBodyHeight: this.max_body_heght, debounceInterval: 700, padding: "dense", exportButton: true,filtering: false,
                headerStyle: {
                    position: "sticky",
                    top: "0",
                    backgroundColor: "#64a179",
                    color: "#FFF",
                    fontSize: "0.9em"
                  },
                  rowStyle: (rowData) => ({
                    fontSize: "1em",
                    backgroundColor:
                      rowData.tableData.id % 2 === 1 ? "#e8f5e2" : "#ffffff"
                  }),
                      pageSize: 10,
                      pageSizeOptions: [10, 25 ,50, 75, 100 ],
                      toolbar: true,
                      paging: true,
                      actionsColumnIndex: -1
                }}
                data={query =>
                  new Promise((resolve, reject) => {
                    // prepare your data and then call resolve like this:
                    let url = API_URL+'/employee_master/GetEmployeeGridData?'
                    let q_search="";
                    let sort="";
                    let order_by="";
                    //searching
                    console.clear()   
                    if (query.search) {
                        q_search=`${query.search}`;
                    }
                    //sorting 
                    if (query.orderBy) {
                        sort= `${query.orderBy.field}`;
                        order_by=`${query.orderDirection}`
                    }
                    url += "&q_search="+q_search
                    url += "&sort="+sort
                    url += "&order_by="+order_by

                    //filtering
                    if (query.filters.length) {
                      const filter = query.filters.map(filter => {
                        return `&${filter.column.field}${filter.operator}${filter.value}`
                      })
                      url += filter.join('')
                    }
                    //pagination
                    url += `&page=${query.page + 1}`
                    url += `&limit=${query.pageSize}`

                    //request options
                    const requestOptions = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': localStorage.getItem('token')
                        },
                        // body: JSON.stringify(data1)
                    };
                    
                    fetch(url,requestOptions).then(resp => resp.json()).then(resp => {
                      resolve({
                        data: resp['data']['data'],// your data array
                        page: query.page,// current page number
                        totalCount:  resp['data']['total_records']// total row number
                      });
                    })
        
                  })
                }
               
                actions={[
                    {
                      icon: 'edit',
                      tooltip: 'Edit',
                      onClick: (event, rowData) => {
                        // Do save operation
                        window.$(".modal").modal("show");
                        this.setState({ user_type_disable: false })  
                         this.edit(rowData);
                        this.getDist('');
                        
                      }
                    }, 
                   
                    {
                        text:'add',
                        icon: () => (
                           
                            <button class="btn btn-primary mr-1" tabindex="0" aria-controls="DataTables_Table_0"  type="button" data-toggle="modal" data-target="#modals-slide-in">
                            <span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus mr-50 font-small-4"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>Add User</span></button>
                        
                          ),
                       
                        tooltip: 'Add User',
                        isFreeAction: true,
                        position: "toolbar",
                        onClick: (event) => {
                            this.setState({ user_zone: { label: "North", value: "North" } })
                            this.setState({ user_status: { label: "Select Status", value: "Select Status" } });
                            this.setState({ bm_name: { label: "Select BM", value: "Select BM" }});  
                            window.$(".modal").modal("show");
                            this.setState({ user_type_disable: false })  ;
                            this.setState({ user_type: { label: "Sales Officer", value: "Sales Officer" }});                            
                            this.setState({ showDistSelectionMenu: 1 })  ;
                                                      

                            this.addkoro()
                        }
                    },
                    {
                        icon: 'mail',
                        tooltip: 'Send Login Password By Mail',
                        onClick: (event, rowData) =>this.SendPasswordByMailByEmployeeLogin(rowData["emp_code"])
                    },
                  ]}
              />
            </div>
          
            <div class="modal modal-slide-in alpha" id="modals-slide-in">
                <div class="modal-dialog sidebar-sm w-50">
                {/* <BlockUi tag="div" blocking={this.state.blocking} message="Please wait" color="red" > */}
                    <form class="add-new-record modal-content pt-0" style={{height:"950px"}}>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">×</button>
                        <div class="modal-header mb-1">
                            <h5 class="modal-title" id="exampleModalLabel">Add User</h5>
                        </div>
                        <div class="modal-body flex-grow-1" id="inputform">
                        <div class="form-row mb-1" >
                            <div class="form-group col-lg-6">
                                <label class="form-label" for="basic-icon-default-fullname">Employee Code <span style={{color:"red"}}>*</span></label>
                                <input type="text" class="form-control dt-full-name" id="fcode"  placeholder="" aria-label="John Doe" />
                            </div>
                            <div class="form-group col-lg-6">
                                <label class="form-label" for="basic-icon-default-fullname">Employee Name<span style={{color:"red"}}>*</span></label>
                                <input type="text" class="form-control dt-full-name" id="lname" placeholder="" aria-label="John Doe" />
                            </div>
                            </div>
                            <div class="form-row mb-1" >
                            <div class="form-group col-lg-6">
                                <label class="form-label" for="basic-icon-default-email">Email<span style={{color:"red"}}>*</span></label>
                                <input type="text" id="email" class="form-control dt-email" placeholder="" aria-label="john.doe@example.com" />

                            </div>
                            
                            <div class="form-group col-lg-6">
                                <label class="form-label" for="basic-icon-default-post">Phone No <span style={{color:"red"}}>*</span></label>
                                <input type="number" id="PH"  maxLength={10}  class="form-control dt-post" placeholder="" aria-label="XXXXXXXXXXX" />
                            </div>
                            </div>
                            <div class="form-row mb-1" >
                            <div class="form-group col-lg-4">
                                <label class="form-label" for="basic-icon-default-email">User Status<span style={{color:"red"}}>*</span></label>
                                {/* <input type="text" id="PPP" class="form-control dt-email" placeholder="" aria-label="" /> */}
                                                    <Select id="ustat"
                                                value={this.state.user_status}
                                                onChange={value =>  this.setState({ user_status: value })}
                                                options={this.user_status_options}
                                                defaultValue={this.user_status_options[0]}
                                                />

                            </div>    
                            <div class="form-group col-lg-4">
                                <label class="form-label" for="basic-icon-default-post">User HQ</label>
                                <input type="text" id="DOB" class="form-control flatpickr-basic" placeholder="" />
                            </div>
                            

                            <div class="form-group col-lg-4">
                                <label class="form-label" for="basic-icon-default-post">User Zone<span style={{color:"red"}}>*</span></label> 
                                                            <Select
                                                value={this.state.user_zone}
                                                onChange={value => this.handleUserZoneChange(value)}
                                                options={this.use_zone_options}
                                                defaultValue={this.use_zone_options[1]}
                                                />
                            </div>
                            
                            <div class="form-group col-lg-6">
                                <label class="form-label" for="basic-icon-default-email">User Type<span style={{color:"red"}}>*</span></label>
                                
                           
                                                <Select
                                                value={this.state.user_type}
                                                onChange={value => this.handleUserTypeChange(value)}
                                                options={this.use_type_options}
                                                isDisabled={this.state.user_type_disable}

                                                defaultValue={this.use_type_options[0]}
                                                />
                            </div>
                            <div class="form-group col-lg-6">
                                <label class="form-label" for="basic-icon-default-email">Region(Sales State)<span style={{color:"red"}}>*</span></label>
                                {/* <input type="text" id="PPP" class="form-control dt-email" placeholder="" aria-label="" /> */}
                                            <Select id="PPP"
                                                value={this.state.user_region}
                                                onChange={value =>  this.setState({ user_region: value })}
                                                options={this.user_region_options}
                                                defaultValue={this.user_region_options[1]}
                                                />

                            </div>
                            <div class="form-group col-lg-6">
                                <label class="form-label" for="basic-icon-default-email">Reporting To (BM)<span style={{color:"red"}}>*</span></label>
                                {/* <input type="text" id="PPP" class="form-control dt-email" placeholder="" aria-label="" /> */}
                                            <Select id="bm"
                                                value={this.state.bm_name}
                                                onChange={value =>  this.setState({ bm_name: value })}
                                                options={this.bm_name_options}
                                                defaultValue={this.bm_name_options[1]}
                                                />

                            </div>
                            <div class="form-group col-lg-6">
                                <label class="form-label" for="basic-icon-default-email">Reporting To (ZSM)<span style={{color:"red"}}>*</span></label>
                                {/* <input type="text" id="PPP" class="form-control dt-email" placeholder="" aria-label="" /> */}
                                            <Select id="zsm"
                                                value={this.state.zsm_name}
                                                onChange={value =>  this.setState({ zsm_name: value })}
                                                options={this.zsm_name_options}
                                                defaultValue={this.zsm_name_options[1]}
                                                />

                            </div>
                            </div>
                            
                            {this.state.showDistSelectionMenu==1?
                            <div class="col-lg-12 mb-2 p-0" data-select2-id="52">
                            <label>Add Distributor</label>
                            
                            <Multiselect  
                            options={this.state.options} 
                            // Options to display in the dropdown
                            selectedValues={this.state.selectedit} // Preselected value to persist in dropdown
                            onSelect={this.onSelect} // Function will trigger on select event
                            onRemove={this.onRemove} // Function will trigger on remove event
                            displayValue="name" // Property name to display in the dropdown options
                            class="form-control dt-email"
                            showCheckbox={true}

                            loading={this.state.load1}
                            loadingMessage="Please wait while all distributors are fetched"
                            onSearch={(val)=>this.getDist(val)}
                            />
                                                                    
                                                                        
                            </div> 
                            :null
                                                                
                         }
                            

                            <button type="button" class="btn btn-primary data-submit mr-1 btn-page-block-overlay waves-effect  " onClick={() => this.submit()}> <i class="fas fa-save mr-50"></i> Submit</button>
                            <button type="reset" class="btn btn-danger btn-outline-secondary" id='close' data-dismiss="modal"><i class="fas fa-times mr-50"></i> Cancel</button>
                        </div>
                    </form>
                    {/* </BlockUi> */}
                </div>
            </div>
            </>
          );
         


    }
}
export default BackofficeNew